/**
 * Created by laszlo.czondor on 2017. 11. 07.
 */
import Cookies from 'js-cookie';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

export default {
	data() {
		return {
			isVisible: false,
			cookieLevels: [] 
		}
	},
	computed: {
		consentRules(){
			return {
				'functionality_storage': 'granted',
				'personalization_storage': 'granted',
				'security_storage': 'granted',
				'analytics_storage': this.cookieLevels.includes('statistics') ? 'granted' : 'denied',
				'ad_storage': this.cookieLevels.includes('marketing') ? 'granted' : 'denied',
				'ad_user_data': this.cookieLevels.includes('marketing') ? 'granted' : 'denied',
				'ad_personalization': this.cookieLevels.includes('marketing') ? 'granted' : 'denied',
			}
		}
	},
	methods: {
		closeNotification(isAccepted) {
			this.isVisible = false;
			if (isAccepted) {
				this.acceptCookies()
			}
		},
		acceptAllCookies(){
			this.cookieLevels = ['base', 'statistics', 'marketing']
			this.acceptCookies()
		},
		acceptCookies(){
			if (!this.cookieLevels.includes('base')) {
				this.cookieLevels.push('base');
			}
			Cookies.set('cookieLevels', this.cookieLevels.toString(), {expires: this.cookieLifeSpanInDays});
			this.sendConsent('update')
			setTimeout(() => {
				this.closeNotification();
				window.isCookieModalOpen = false;
			}, 200);
		},
		sendConsent(type){
			gtag('consent', type, this.consentRules);
		},
		toggleAccordion(id){
			const accordions = document.querySelectorAll('.not03-notification__accordion')
			const accordion = document.getElementById(id);
			if (accordion.classList.contains('open')) {
				accordion.classList.remove('open');
			} else {
				accordions.forEach((elem) => {
					elem.classList.remove('open');
				})
				accordion.classList.add('open');
			}
		}
	},
	props: {
		cookieLifeSpanInDays: {
			type: Number,
			default: 365 // one year
		}
	},
	mounted() {
		const footerLink = document.getElementById('cookiePolicyLink');
		footerLink.addEventListener('click', (e) => { e.preventDefault(); this.isVisible = true})
		this.cookieLevels = Cookies.get('cookieLevels') ? Cookies.get('cookieLevels').split(',') : []
		this.isVisible = !this.cookieLevels.length;
		if (!this.cookieLevels.length) {
			this.sendConsent('default')
			this.$nextTick(() => {
				this.cookieLevels.push('statistics')
			})
		} else {
			this.sendConsent('update')
		}
	}
}



// WEBPACK FOOTER //
// ../source/common/cookie-notification/gdpr-notification.js